import {fetchApiVersion} from "../net/NetConstants";

export const API_VERSION = "/api/v1/";
export const HTTP_METHOD_POST = "POST";
export const HTTP_METHOD_GET = "GET";

export const doHttpRequest = (uri, payload, handler, errorHandler, method) => {

    errorHandler = errorHandler ? errorHandler : () => {};

    method = method ? method : "POST";

    const requestOptions = {
        method: method,
        headers: { 'Content-Type': 'application/json' },
        body: payload ? JSON.stringify(payload) : null
    };

    fetch(fetchApiVersion() + uri, requestOptions)
        .then(response => response.json())
        .then(data => handler(data))
        .catch((e) => errorHandler(e));
}